import { IntlShape } from 'react-intl'
import { create, enforce, group, omitWhen, test } from 'vest'
import {
  MaxPrice,
  MaxShipping,
  Nominal,
  NominalLoyalty,
  NominalShipping,
  Percentual,
  PercentualLoyalty,
  PercentualShipping,
  RegularBenefit,
  RegularFreeShipping,
  RegularGift,
} from '../../../../../../typings'
import {
  validationSuiteFormula,
  validationSuiteFreeShipping,
  validationSuiteMaxPrice,
  validationSuiteMaxShipping,
  validationSuiteNominal,
  validationSuiteNominalLoyalty,
  validationSuiteNominalShipping,
  validationSuitePercentual,
  validationSuitePercentualLoyalty,
  validationSuitePercentualShipping,
  validationPriceTable,
  validationSuiteGift,
} from '../Variants'
import { Formula, PriceTable } from './../../../../../../typings/regular'

export function benefitValidation(intl: IntlShape) {
  return create((benefit: RegularBenefit) => {
    group('benefit', () => {
      omitWhen(!benefit?.type, () => {
        validationSuiteNominal(intl)(benefit as Nominal)
        validationSuitePercentual(intl)(benefit as Percentual)
        validationSuiteMaxPrice(intl)(benefit as MaxPrice)
        validationSuiteNominalShipping(intl)(benefit as NominalShipping)
        validationSuitePercentualShipping(intl)(benefit as PercentualShipping)
        validationSuiteFreeShipping(intl)(benefit as RegularFreeShipping)
        validationSuiteMaxShipping(intl)(benefit as MaxShipping)
        validationSuiteNominalLoyalty(intl)(benefit as NominalLoyalty)
        validationSuiteGift(intl)(benefit as RegularGift)
        validationSuitePercentualLoyalty(intl)(benefit as PercentualLoyalty)
        validationSuiteFormula(intl)(benefit as Formula)
        validationPriceTable(intl)(benefit as PriceTable)
      })
    })
  })
}
